import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useCallback } from 'react';
import { usePopper } from 'react-popper';
import { TaktIdProvider, createStormTaktId } from '@amzn/storm-ui';
import { P as PopperWrapper } from './FormLayout.styles-BzYy_4z2.js';
import { t as textDirectionSensitiveFn } from './popperModifiers/textDirectionSensitive-CLVsfVa0.js';
import { P as Portal } from './Portal-H7Hzq_Pr.js';
import { g as getFocusableElements } from '../../LocalModules/storm-ui-utils/dist/esm/focusableElements/getFocusableElements-BjFtn5aB-BjFtn5aB.js';
import { t as trapTabFocus } from '../../LocalModules/storm-ui-utils/dist/esm/focusableElements/trapTabFocus-vpg0lK2r-Bk1xQ7S4.js';

const FormLayoutPopperWrapper = ({
  anchorElement,
  children,
  isOpen,
  offset,
  placement,
  portalElementId,
  strategy,
  style,
  taktId,
  taktValue,
  ...restProps
}) => {
  const [popperElement, setPopperElement] = useState(null);
  const {
    attributes,
    styles,
    update
  } = usePopper(anchorElement, popperElement, {
    placement,
    strategy,
    modifiers: [{
      name: 'textDirectionSensitive',
      enabled: true,
      phase: 'beforeRead',
      fn: textDirectionSensitiveFn
    }, {
      name: 'offset',
      options: {
        offset
      }
    }]
  });
  React__default.useEffect(() => {
    if (isOpen) {
      if (typeof update === 'function') {
        update();
      }
    }
  }, [isOpen, update]);
  React__default.useEffect(() => {
    if (!isOpen) {
      var _anchorElement$focus;
      anchorElement === null || anchorElement === void 0 || (_anchorElement$focus = anchorElement.focus) === null || _anchorElement$focus === void 0 || _anchorElement$focus.call(anchorElement);
    }
  }, [isOpen, anchorElement]);
  React__default.useEffect(() => {
    if (isOpen) {
      if (popperElement) {
        const focusableEls = getFocusableElements(popperElement);
        if (focusableEls.length > 0) {
          focusableEls[0].focus();
        }
      }
    }
  }, [isOpen, popperElement]);

  /**
   * Handles keyboard KeyDown input when the popover surface is in focus.
   */
  const handleKeyDown = useCallback(event => {
    if (popperElement) {
      // Trap the focus of the browser inside the popover element. Keep the user in this element
      // and allow them to tab through content until the user closes the <Popover />.
      trapTabFocus(event, popperElement, false);
    }
  }, [popperElement]);
  return /*#__PURE__*/React__default.createElement(Portal, {
    portalElementId: portalElementId
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('form-layout-popper-wrapper')
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, restProps, {
    ref: ref => setPopperElement(ref),
    style: {
      ...style,
      ...styles.popper,
      display: isOpen ? 'block' : 'none'
    }
  }, attributes.popper, {
    onKeyDown: handleKeyDown,
    role: "presentation"
  }), /*#__PURE__*/React__default.createElement(PopperWrapper, null, children))));
};

export { FormLayoutPopperWrapper as F };
//# sourceMappingURL=FormLayoutPopperWrapper-DQZPaJ9e.js.map
